import { createFilterOptions, FilterOptionsState } from "@mui/material";

import { PriorCarrierName } from "@covertree/new-business-graphql";
import { OptionType } from "@covertree/types";

export const filterOptions = (
  opts: OptionType[],
  state: FilterOptionsState<OptionType>
) => {
  // get default results from material ui's createFilterOptions
  const defaultResults = createFilterOptions<OptionType>()(opts, state);
  return defaultResults;
};

export const options: { label: string; value: string }[] = [
  { label: "Aegis", value: PriorCarrierName.Aegis },
  { label: "Allstate", value: PriorCarrierName.Allstate },
  { label: "Assurant", value: PriorCarrierName.Assurant },
  { label: "American Bankers", value: PriorCarrierName.AmericanBankers },
  { label: "American Modern", value: PriorCarrierName.AmericanModern },
  { label: "American Reliable", value: PriorCarrierName.AmericanReliable },
  { label: "American Summit", value: PriorCarrierName.AmericanSummit },
  { label: "Bankers", value: PriorCarrierName.Bankers },
  { label: "Foremost", value: PriorCarrierName.Foremost },
  { label: "Homesite", value: PriorCarrierName.Homesite },
  { label: "Kin", value: PriorCarrierName.Kin },
  { label: "Liberty Mutual", value: PriorCarrierName.LibertyMutual },
  { label: "National Lloyds", value: PriorCarrierName.NationalLloyds },
  { label: "National Security", value: PriorCarrierName.NationalSecurity },
  { label: "Pacific Specialty", value: PriorCarrierName.PacificSpecialty },
  { label: "Progressive", value: PriorCarrierName.Progressive },
  { label: "Shelter", value: PriorCarrierName.Shelter },
  { label: "State Farm", value: PriorCarrierName.StateFarm },
  { label: "Tower Hill", value: PriorCarrierName.TowerHill },
  { label: "USAA", value: PriorCarrierName.Usaa },
  {
    label: "Not Listed",
    value: PriorCarrierName.NotListed,
  },
];
